module.exports = __webpack_public_path__ + "img/wagon-shirt.d59fec6a.png";